import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { BackgroundEraserForm } from "../../../components/BackgroundEraserForm";
import { useGlobalSettingsProvider } from "../../../utilities/global-settings/hooks";
import {
  BackgroundEraserRootParamList,
  SettingsRootParamList,
} from "../../../types";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { CardStyleInterpolators } from "@react-navigation/stack";
import { SelectBgRemovalStrategyScreen } from "./SelectBgRemovalStrategyScreen";
import { BackgroundEraserSettingsScreen } from "./BackgroundEraserSettingsScreen";

const Stack = createStackHeaderNavigator<BackgroundEraserRootParamList>();

export type BackgroundEraserSettingsRootScreenProps = NativeStackScreenProps<
  SettingsRootParamList,
  "BackgroundEraserSettingsRootScreen"
>;

export const BackgroundEraserSettingsRootScreen =
  ({}: BackgroundEraserSettingsRootScreenProps) => {
    const globalSettings = useGlobalSettingsProvider();
    return (
      <BackgroundEraserForm
        defaultFormValues={{
          bgApiKey: globalSettings.removalBgDetails?.apiKey || "",
          aiApiKey: globalSettings.removalAiDetails?.apiKey || "",
          bgRemovalStrategy: globalSettings.bgRemovalStrategy || "",
          automaticBackgroundRemoval:
            globalSettings.automaticBackgroundRemoval || false,
        }}
      >
        <Stack.Navigator
          screenOptions={{
            title: "",
            headerLeft: () => <ModalCloseButton type="Back" />,
            animationEnabled: true,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          }}
        >
          <Stack.Screen
            name="BackgroundEraserSettingsScreen"
            component={BackgroundEraserSettingsScreen}
          />
          <Stack.Screen
            name="SelectBgRemovalStrategyScreen"
            component={SelectBgRemovalStrategyScreen}
          />
        </Stack.Navigator>
      </BackgroundEraserForm>
    );
  };
